module.exports = __webpack_public_path__ + "img/website-icon.d3e56cfa.svg";